import { or as t } from "./abstract-base-0be59b32-472aea73.js";
const r = {
  DOWN: t`<svg
    class="tooltip-arrow arrow--down"
    viewBox="0 0 12 6"
    xmlns="http://www.w3.org/2000/svg"
    style="transform: rotate(180deg);"
  >
    <path d="M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z"></path>
  </svg>`,
  LEFT: t`<svg
    class="tooltip-arrow arrow--left"
    viewBox="0 0 12 6"
    xmlns="http://www.w3.org/2000/svg"
    style="transform: rotate(270deg) scale(2);"
  >
    <path d="M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z"></path>
  </svg>`,
  RIGHT: t`<svg
    class="tooltip-arrow arrow--right"
    viewBox="0 0 12 6"
    xmlns="http://www.w3.org/2000/svg"
    style="transform: rotate(90deg) scale(2);"
  >
    <path d="M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z"></path>
  </svg>`,
  UP: t`<svg class="tooltip-arrow arrow--up" viewBox="0 0 12 6" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 0.998535L12 6.99854L0 6.99854L6 0.998535Z"></path>
  </svg>`
};
export {
  r
};
